import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlShortenerService {
  private urlMap: Map<string, string> = new Map();

  constructor() { }

  // Generate a short code and store the full URL
  shortenUrl(fullUrl: string): string {
    // Generate a unique short code
    const shortCode = this.generateShortCode();
    
    // Store the mapping
    this.urlMap.set(shortCode, fullUrl);
    
    // Return the shortened URL
    const baseUrl = window.location.origin;
    return `${baseUrl}/s/${shortCode}`;
  }

  // Retrieve the full URL from the short code
  getFullUrl(shortCode: string): string | null {
    return this.urlMap.get(shortCode) || null;
  }

  // Generate a random short code
  private generateShortCode(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 8; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }
}